import { getItemFromCollection } from "directus/src/operations";

export async function fetchCountryData({ countryId }) {
  try {
    const response = await getItemFromCollection("countries", countryId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
